import { render, staticRenderFns } from "./ServiceFormCreate.vue?vue&type=template&id=498bde6a&scoped=true&"
import script from "./ServiceFormCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceFormCreate.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormCreate.vue?vue&type=style&index=0&id=498bde6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498bde6a",
  null
  
)

export default component.exports